'use client'

import { isEmpty } from 'lodash-es'
import { useTranslations } from 'next-intl'
import { useFormContext, useWatch } from 'react-hook-form'

import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
  autoComplete?: boolean
}

export const PasswordField = ({
  placeholder,
  readOnly = false,
  disabled = false,
  autoComplete = false,
}: Props) => {
  const t = useTranslations('account')

  const { control, clearErrors, formState } = useFormContext()
  const passwordConfirm = useWatch({
    control,
    name: 'passwordConfirm',
  })

  const handleChange = () => {
    const isPasswordMatchError =
      !!formState.errors.passwordConfirm && !isEmpty(passwordConfirm)

    if (isPasswordMatchError) {
      clearErrors('passwordConfirm')
    }
  }

  return (
    <Form.Field
      name="password"
      readOnly={readOnly}
      disabled={disabled}
      onChange={handleChange}
    >
      <Form.Label className="font-medium text-black">
        {t('password_label')}
      </Form.Label>
      <Form.PasswordField
        placeholder={placeholder || t('password_placeholder')}
        fullWidth
        readOnly={readOnly}
        {...(!autoComplete && { autoComplete: 'new-password' })}
      />
      <Form.Message />
    </Form.Field>
  )
}
